import gql from 'graphql-tag';

export const search = gql`
  query searchPatientByMrn($input: String) {
    searchPatientByMrn(clientMrn: $input) {
      code
      status
      data {
        id
        firstName
        middleName
        lastName
        idNumber
        serviceNumber
        birthDate
        dobEstimated
        mrn
        mobileNumber
        citizenShip {
          id
          name
        }
        administrativeArea {
          id
          name
          label
        }
        maritalStatus {
          id
          name
          description
        }
        occupation {
          name
        }
        sex
        tribe {
          id
          name
        }
      }
    }
  }
`;

export const startVisit = gql`
  mutation startVisit($input: VisitStartDtoInput) {
    startVisit(visitStartDto: $input) {
      code
      status
      data {
        id
        clientName
        clientMrn
        administrativeAreaId
        costSharingModeSubgroupId
      }
    }
  }
`;

export const area = gql`
  query searchAdministrativeAreaByName($input: String) {
    searchAdministrativeAreaByName(administrativeName: $input) {
      code
      status
      data {
        id
        name
        label
      }
    }
  }
`;
export const save = gql`
  mutation savePatient($input: PatientDtoInput) {
    savePatient(patientDto: $input) {
      code
      status
      data {
        id
        firstName
        middleName
        lastName
        idNumber
        serviceNumber
        birthDate
        dobEstimated
        mrn
        mobileNumber
        citizenShip {
          id
          name
        }
        administrativeArea {
          id
          name
          label
        }
        maritalStatus {
          id
          name
          description
        }
        occupation {
          name
        }
        sex
        tribe {
          id
          name
        }
      }
    }
  }
`;
export const tribe = gql`
  query searchTribe($input: String) {
    searchTribe(tribeName: $input) {
      code
      status
      data {
        id
        name
      }
    }
  }
`;
